import LoadingState from './LoadingState';
export default LoadingState;